exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/auth/signin/ex-notification-confirm-action/ex-notification-confirm-action.component.css
// module id = ../../../../../src/app/auth/signin/ex-notification-confirm-action/ex-notification-confirm-action.component.css
// module chunks = main